// extracted by mini-css-extract-plugin
export default {"stepTitle":"OtpStep_stepTitle-cOf","confirmWrapper":"OtpStep_confirmWrapper-eh4","confirmText":"OtpStep_confirmText-HUn","buttonResend":"OtpStep_buttonResend-rFi"};